import { ApprovedPharmacyListItem, ApprovedPharmacyLookup } from '../../../../pages/admin-dashboard/admin-approved-pharmacies/approved-pharmacies.model';
import { PharmacyTableRow, TeleSalesTableRow } from './approved-ph-table.model';

function toPharmacyTableRow(pharmacy: ApprovedPharmacyListItem, isArabic: boolean): PharmacyTableRow {
  return {
    id: pharmacy.id,
    pharmacyNickname: pharmacy.nickName.length > 30 ? pharmacy.nickName.slice(0, 30) + '...' : pharmacy.nickName,
    pharmacyOwner: pharmacy.pharmacyOwner.fullName,
    assignedTo: pharmacy.teleSalesEmployee?.fullName ?? undefined,
    representative: pharmacy.representative?.fullName ?? (pharmacy as any).salesRepresentative?.fullName ?? undefined,
    pharmacyCredit: pharmacy.pharmacyCredit != null ? pharmacy.pharmacyCredit.toString() : null,
    pharmacySegment: pharmacy.pharmacySegment
      ? isArabic
        ? pharmacy.pharmacySegment.titleAr
        : pharmacy.pharmacySegment.titleEn
      : null,
    createdOn: pharmacy.createdOn,
    createdBy: pharmacy?.createdBy?.fullName,
    lastModifiedOn: pharmacy?.lastModifiedOn ?? null,
    lastModifiedBy: pharmacy?.lastModifiedBy?.fullName,
  };
}

export function toPharmacyTableRows(pharmacies: ApprovedPharmacyListItem[], isArabic: boolean): PharmacyTableRow[] {
  return pharmacies.map((p) => toPharmacyTableRow(p, isArabic));
}

function localizedTitle(lookup: ApprovedPharmacyLookup | null | undefined, isArabic: boolean): string | null {
  return (isArabic ? lookup?.titleAr : lookup?.titleEn) || null;
}

export function toTeleSalesTableRows(pharmacies: ApprovedPharmacyListItem[], isArabic: boolean): TeleSalesTableRow[] {
  return pharmacies.map((pharmacy) => ({
    id: pharmacy.id,
    pharmacyCode: String(pharmacy.id),
    pharmacyOwnerLabel: [pharmacy.nickName, pharmacy.pharmacyOwner?.fullName].filter(Boolean).join(' / '),
    address: [pharmacy.region, pharmacy.city, pharmacy.governorate]
      .map((location) => localizedTitle(location, isArabic))
      .filter(Boolean)
      .join(' - '),
    phone: pharmacy.pharmacyOwnerPhoneNumber ?? '',
    representative: pharmacy.representative?.fullName ?? '',
    availableCredit: pharmacy.remainingCredit ?? 0,
    activityStatus: pharmacy.status ?? null,
  }));
}
